import type { ReactNode } from 'react';
import { TopNav } from './TopNav';
import { Footer } from './Footer';

interface PageShellProps {
  children: ReactNode;
  showFooter?: boolean;
  showNav?: boolean;
  className?: string;
  mainClassName?: string;
}

export function PageShell({
  children,
  showFooter = false,
  showNav = true,
  className = '',
  mainClassName = '',
}: PageShellProps) {
  return (
    <div className={className}>
      {showNav && <TopNav />}
      <main className={mainClassName}>{children}</main>
      {showFooter && <Footer />}
    </div>
  );
}
